import { z } from 'zod';

export const SBranchUser = z.object({
  id: z.number(),
  first_name: z.string(),
  last_name: z.string(),
  email: z.string(),
  phone_number: z.string(),
});
export type TBranchUser = z.infer<typeof SBranchUser>;
